import React from "react";
import { Select } from "antd";

const SearchableSelect = ({
  options = [],
  value,
  onChange,
  error = "",
  label = "",
  placeholder = "Select...",
  variant = "desktop",
  className = "",
  dropdownClassName = "",
  selectClassName = "",
  loading = false,
  disabled = false,
  suffixIcon,
  onFocus
}) => {
  // Normalize options to { value, label } format
  const normalizedOptions = options.map((opt) =>
    typeof opt === "string" ? { value: opt, label: opt } : opt
  );

  const blurActive = () => {
    setTimeout(() => {
      if (document?.activeElement?.blur) document.activeElement.blur();
    }, 0);
  };

  const defaultSelectClass =
    variant === "mobile" ? "suburb-select-mobile" : "suburb-select-desktop";
  const defaultPopupClass =
    variant === "mobile"
      ? "member-setup-dropdown-mobile"
      : "member-setup-dropdown-desktop";

  return (
    <div className={`relative ${className}`}>
      {label && (
        <label
          className={`block ${variant === "mobile" ? "text-[14px]" : "text-[12px]"
            } font-[600] font-poppins text-[#303030] mb-2`}
        >
          {label}
        </label>
      )}
      <Select
        showSearch
        virtual={false}
        value={value || undefined}
        placeholder={placeholder}
        options={normalizedOptions}
        optionFilterProp="label"
        autoClearSearchValue
        suffixIcon={suffixIcon || (
          <svg
            className={`${variant === "mobile" ? "w-5 h-5" : "w-4 h-4"} text-[#303030] member-setup-down-arrow`}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.25 8.29a.75.75 0 01-.02-1.08z" clipRule="evenodd" />
          </svg>
        )}
        disabled={disabled}
        onSelect={() => blurActive()}
        onChange={(val) => {
          onChange?.(val || "");
          blurActive();
        }}
        onFocus={onFocus}
        loading={loading}
        notFoundContent={loading ? "Loading..." : "No results found"}
        status={error ? "error" : ""}
        className={`w-full ${selectClassName || defaultSelectClass}`}
        popupClassName={dropdownClassName || defaultPopupClass}
        style={{ width: "100%" }}
      />
      {error && (
        <p
          className={`${variant === "mobile" ? "text-[12px]" : "text-[11px]"
            } text-red-500 mt-3`}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default SearchableSelect;
